<div class="meeting-review" [class.mobile]="deviceService.isMobile()">
  <div class="header">
    <div class="reporter-photo">
      <on-ui-cover [cover]="avatar"></on-ui-cover>
    </div>
    <div class="review">
      <div class="first-line">
        <div class="info">
          <a [routerLink]="reporterRoute" [title]="meetingReview.reporterName" class="name">
            {{ meetingReview.reporterName }}
          </a>
        </div>
        <div class="edit-link" *ngIf="isMe" (click)="edit()">
          {{ 'review.edit-review' | customLocale }}
        </div>
      </div>
      <div *ngIf="isMeeting" class="meeting-info">
        <p class="type">{{ 'review.private-class' | customLocale }}:</p>
        <div class="meeting-cover">
          <on-ui-cover [cover]="cover"></on-ui-cover>
        </div>
        <p class="title">{{ meetingReview.entryTitle }}</p>
      </div>
      <div class="second-line">
        <div class="rating">
          <app-icon *ngFor="let rating of [1, 2, 3, 4, 5]; trackBy: trackByFn"
               [class.active]="rating <= meetingReview.rating"
               class="rating-icon"
               width="16" height="16" icon="rating">
          </app-icon>
          <span class="date" *ngIf="reviewDate">{{reviewDate | zonedDate: me?.timezone | dfnsFormat: 'LLLL dd, yyyy'}}</span>
        </div>
      </div>
      <p class="text-review">{{ meetingReview.comment }}</p>
    </div>
  </div>
</div>
